var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2742_744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1H10C9.45001 1 9.00001 1.45 9.00001 2C9.00001 2.55 9.45001 3 10 3H14C14.55 3 15 2.55 15 2C15 1.45 14.55 1 14 1ZM12 14C12.55 14 13 13.55 13 13V9C13 8.45 12.55 8 12 8C11.45 8 11 8.45 11 9V13C11 13.55 11.45 14 12 14ZM19.03 7.39L19.78 6.64C20.16 6.26 20.17 5.63 19.78 5.24L19.77 5.23C19.38 4.84 18.76 4.85 18.37 5.23L17.62 5.98C16.07 4.74 14.12 4 12 4C7.20001 4 3.12001 7.96 3.00001 12.76C2.87001 17.84 6.94001 22 12 22C16.98 22 21 17.97 21 13C21 10.88 20.26 8.93 19.03 7.39ZM12 20C8.13001 20 5.00001 16.87 5.00001 13C5.00001 9.13 8.13001 6 12 6C15.87 6 19 9.13 19 13C19 16.87 15.87 20 12 20Z",
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2742_744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.d318892614a9f91e7a5049815199df06.svg";
export { ForwardRef as ReactComponent };